export default function EthereumIcon() {
  return (
    <svg
      className="tw-w-full tw-h-full tw-align-top"
      viewBox="0 0 112 182"
      fill="none"
      aria-hidden="true"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M55.8647 0L0 92.6869L55.8647 67.3005V0Z" fill="currentColor" />
      <path
        d="M55.8647 67.3005L0 92.687L55.8647 125.711V67.3005Z"
        fill="currentColor"
      />
      <path
        d="M111.729 92.6869L55.8647 0V67.3005L111.729 92.6869Z"
        fill="currentColor"
      />
      <path
        d="M55.8647 125.711L111.729 92.687L55.8647 67.3005V125.711Z"
        fill="currentColor"
      />
      <path d="M0 103.284L55.8647 182V136.288L0 103.284Z" fill="currentColor" />
      <path
        d="M55.8647 136.288V182L111.76 103.284L55.8647 136.288Z"
        fill="currentColor"
      />
    </svg>
  );
}
